import { CategoryService } from "@/api/services/category.service";
import { PortalAdapterApi } from "@vacancorp/portal.adapter.api";

export default function useFilterGenreUsecase() {
  async function fetchGenreList(
    country = "jp",
    mapType?: string,
  ): Promise<PortalAdapterApi.ResponseGetPlaceCategoryList> {
    // No need to show 避難所、投票所 to normal map
    if (!mapType) {
      const response: PortalAdapterApi.ResponseGetPlaceCategoryList = await CategoryService.fetchGenresV2(country);
      return response.filter(
        (genre: PortalAdapterApi.PlaceCategory) =>
          genre.placeCategoryType !== "evacuation-center" && genre.placeCategoryType !== "polling-place",
      );
    } else {
      const response: PortalAdapterApi.ResponseGetPlaceCategoryList = await CategoryService.fetchGenresV2(
        country,
        mapType,
      );
      return response;
    }
  }

  async function findCategoryList(genreName: string): Promise<PortalAdapterApi.GenreCategoryType> {
    return await CategoryService.fetchCategoryListByGenreV1(genreName);
  }

  async function findNonNormalMapTypes(genresName: string) {
    return await CategoryService.fetchMapTypesForGenres(genresName);
  }

  return {
    fetchGenreList,
    findCategoryList,
    findNonNormalMapTypes,
  };
}
